// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6p15x","toggleWrap":"styles_toggleWrap__1j0H6","content":"styles_content__2vd_d","selectAreaCode":"styles_selectAreaCode__2eqG9"};